import React from 'react';
import type { Control } from 'react-hook-form';

import Input from '@components/uikit/Input/Input';

import useTranslation from '@hooks/useTranslation';

import { type IWarrantyForm, WARRANTY_FIELDS } from '../../constants/schemaWarranty';
import style from './style.module.scss';

interface IProps {
  control: Control<IWarrantyForm>;
}

const StepPersonalInformation: React.FC<IProps> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <div className={style.stepPersonalInformationContainer}>
      <Input control={control} name={WARRANTY_FIELDS.FULL_NAME} label={t('Full Name')} required />
      <Input control={control} name={WARRANTY_FIELDS.JOB_TITLE} label={t('Job Title')} />
      <Input control={control} name={WARRANTY_FIELDS.EMAIL_ADDRESS} label={t('Email Address')} required />
      <Input control={control} name={WARRANTY_FIELDS.CONTACT_PHONE} label={t('Contact Phone')} required />
      <Input
        control={control}
        name={WARRANTY_FIELDS.COMPANY_NAME_AND_FACILITY_NAME}
        label={t('Company Name and Facility Name/Code')}
        required
      />
      <Input
        control={control}
        name={WARRANTY_FIELDS.SHIPPING_ADDRESS}
        label={t('Shipping Address')}
        required
        tooltipContent={t('Enter the address of the facility where the replacement parts should be sent.')}
        tooltipPlace="bottom-end"
      />
    </div>
  );
};

export default StepPersonalInformation;
